import { render, staticRenderFns } from "./edit-stock.vue?vue&type=template&id=43b7dbbc&scoped=true&lang=pug&"
import script from "./edit-stock.vue?vue&type=script&lang=js&"
export * from "./edit-stock.vue?vue&type=script&lang=js&"
import style0 from "./edit-stock.vue?vue&type=style&index=0&id=43b7dbbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b7dbbc",
  null
  
)

export default component.exports